import {
FaHome,
FaClipboardList,
FaUsers,
FaBoxOpen,
FaCalendarAlt,
FaComments,
} from "react-icons/fa";

export const procurementNavigation = [
{
id: "dashboard",
icon: FaHome,
label: "Обзор",
path: "/procurement",
},
{
id: "requests",
icon: FaClipboardList,
label: "Заявки на поиск",
path: "/procurement/requests",
},
{
id: "suppliers",
icon: FaUsers,
label: "Поставщики",
path: "/procurement/suppliers",
},
{
id: "products",
icon: FaBoxOpen,
label: "Товары",
path: "/procurement/products",
},
{
id: "calendar",
icon: FaCalendarAlt,
label: "Календарь",
path: "/procurement/calendar",
},

{
  id: "chat",
  icon: FaComments,
  label: "Чат",
  path: "/procurement/chat",
},
];
